import { createConsumer } from "@rails/actioncable"

const cable = createConsumer()
cable.subscriptions.create('UserChannel', {
  received: (msg) => {
    console.log('UserChannel:', msg)
  }
})

export default cable
